import { useDisableFlags } from './useDisableFlags'
import { PlaceInAkixiNameSpace } from '../../../NonReact/utils/Utils'

export const useDisableUserInfoErrors = (): void => {
    useDisableFlags('disableUserInfoErrors', true)
}

PlaceInAkixiNameSpace('useDisableUserInfoErrors', useDisableUserInfoErrors)
